var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletDolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.467,
    height: 64,
    viewBox: "0 0 55.467 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tablet-dolar",
    transform: "translate(-3 -1.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31511",
    "data-name": "Trazado 31511",
    d: "M3,10.026a8.531,8.531,0,0,1,8.533-8.533H45.667v19.2a2.133,2.133,0,1,1-4.267,0V5.759H28.6a2.14,2.14,0,0,1-2.133,2.133H22.2a2.14,2.14,0,0,1-2.133-2.133H11.533a4.279,4.279,0,0,0-4.267,4.267V56.959H30.733a2.133,2.133,0,0,1,0,4.267H3Z",
    transform: "translate(0 0)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31512",
    "data-name": "Trazado 31512",
    d: "M32.067,23.292A4.279,4.279,0,0,0,27.8,19.026v8.533a8.533,8.533,0,1,1,0,17.067v2.133a2.133,2.133,0,1,1-4.267,0V44.626A8.531,8.531,0,0,1,15,36.092a2.133,2.133,0,0,1,4.267,0,4.279,4.279,0,0,0,4.267,4.267V31.826a8.533,8.533,0,0,1,0-17.067V12.626a2.133,2.133,0,1,1,4.267,0v2.133a8.531,8.531,0,0,1,8.533,8.533,2.133,2.133,0,1,1-4.267,0Zm-8.533-4.267a4.267,4.267,0,0,0,0,8.533Zm8.533,17.067A4.279,4.279,0,0,0,27.8,31.826v8.533A4.279,4.279,0,0,0,32.067,36.092Z",
    transform: "translate(22.133 16.6)",
    fill: "#00c1d4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletDolar);
export default __webpack_public_path__ + "static/media/tablet-dolar.f53cb298568e59c2a34902a1041ef9d5.svg";
export { ForwardRef as ReactComponent };